import type { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';
import type { RoutesPlannerRun } from '../../types';
import { etaRoutesProvider, RouteNode } from '../eta/eta-routes-provider';
import type RoutesPlannerStore from '../../stores/routes-planner-store';
import { etaRoutesConverter } from '../eta/eta-routes-converter';

const getByRouteId = (
	routeId: number,
	routesPlannerStore: RoutesPlannerStore
): (RoutesPlannerRun | EtaResponseRouteItem)[] => {
	const route = routesPlannerStore.routeInfoByIndex[routeId] || routesPlannerStore.routesById[routeId];
	const changedRoute = etaRoutesConverter.routeToRunChangedParams(
		route,
		routesPlannerStore.runToTasks[routeId],
		routesPlannerStore.runToBreaks[routeId]
	);

	return etaRoutesProvider
		.getRouteNodes(changedRoute, routesPlannerStore)
		.map(routeInGroup => getRoute(routeInGroup, routesPlannerStore))
		.filter(routeInGroup => etaRoutesConverter.getRouteId(routeInGroup) !== routeId);
};

function getRoute(routeInGroup: RouteNode, routesPlannerStore: RoutesPlannerStore) {
	return (
		routesPlannerStore.consecutiveRoutesStore.routesById.get(routeInGroup.route.runId) ||
		routesPlannerStore.routeInfoByIndex[routeInGroup.route.runId] ||
		routesPlannerStore.routesById[routeInGroup.route.runId]
	);
}

export const consecutiveRoutesProvider = { getByRouteId };
